var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#4795ff;}.cls-5{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1109.1,
    r: 579.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1025,862.9c189.4,0,359.4-32.8,475.6-84.9C1395.9,627.9,1221.9,529.7,1025,529.7S654.1,627.9,549.4,778C665.6,830.1,835.6,862.9,1025,862.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1038.6,361.5c-302.2,0-547.2,91.6-547.2,204.6s245,204.5,547.2,204.5,547.2-91.6,547.2-204.5S1340.8,361.5,1038.6,361.5Zm0,315.6c-209.2,0-378.7-49.7-378.7-111s169.5-111,378.7-111,378.8,49.7,378.8,111S1247.8,677.1,1038.6,677.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1023.5,1462.5c-76.5,0-148.6-30.7-202.9-86.5a30,30,0,1,1,43-41.9c42.9,44.1,99.7,68.4,159.9,68.4s119.3-25.3,162.6-71.2a30,30,0,1,1,43.6,41.1,285.4,285.4,0,0,1-92.3,65.8A275.9,275.9,0,0,1,1023.5,1462.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M825.5,1174.6c-29.9,0-59.2-13.7-86.8-40.7a30,30,0,0,1,41.9-43c16,15.7,31.2,23.7,44.9,23.7s28.9-8,44.9-23.7a30,30,0,1,1,41.9,43C884.7,1160.9,855.5,1174.6,825.5,1174.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1224.5,1174.6c-30,0-59.2-13.7-86.8-40.7a30,30,0,1,1,41.9-43c16,15.7,31.1,23.7,44.9,23.7s28.9-8,44.9-23.7a30,30,0,0,1,41.9,43C1283.7,1160.9,1254.4,1174.6,1224.5,1174.6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEase);
export default __webpack_public_path__ + "static/media/ease.cd66de6dd4d76daf24c483ad966ddd7e.svg";
export { ForwardRef as ReactComponent };